import React from "react";
import { Loader2 } from "lucide-react";
import { Button } from "components/ui/button";

const LiveDashboardGate = ({ gate, goBack, navigate }) => {
  if (gate === "invalid") {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center gap-4 bg-[#F5F5F5] p-6">
        <p className="text-sm text-gray-600">Invalid live dashboard link.</p>
        <Button type="button" variant="outline" onClick={() => navigate("/prize-leaderboard")}>
          Back to Prize Leaderboard
        </Button>
      </div>
    );
  }

  if (gate === "loading") {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F5F5F5]">
        <Loader2 className="h-8 w-8 animate-spin text-gray-400" />
      </div>
    );
  }

  if (gate === "not_found") {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center gap-4 bg-[#F5F5F5] p-6">
        <p className="text-sm text-gray-600">Contest round not found.</p>
        <Button type="button" variant="outline" onClick={goBack}>
          Back to Prize Leaderboard
        </Button>
      </div>
    );
  }

  return null;
};

export default LiveDashboardGate;
